<script lang="ts" setup>
import { useField } from "vee-validate";
import { ExclamationCircleIcon, XCircleIcon } from "@heroicons/vue/solid";
import BaseInput from "./_base.vue";

interface Props {
    type?: string;
    value?: string | number;
    name: string;
    label: string;
    placeholder: string;
    autocomplete?: string;
    required?: boolean;
    locked?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    type: "text",
    value: undefined,
    name: undefined,
    label: undefined,
    placeholder: undefined,
    autocomplete: "",
    required: false,
    locked: false,
});

const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
} = useField(props.name, undefined, {
    initialValue: props.value,
});

function customHandleChange(e: Event) {
    const target = e.target;
    if (props.type === "number") {
        // @ts-ignore
        handleChange(Number(target?.value));
    } else {
        handleChange(e);
    }
}
</script>

<template>
    <BaseInput :errorMessage="errorMessage" :required="required" :meta="meta" :name="name" :label="label">
        <div class="mt-2 relative z-[2]">
            <component
                :is="type !== 'textarea' ? 'input' : 'textarea'"
                class="appearance-none block w-full border text-sm font-medium border-[#D4DBE2] rounded transition-colors p-[15px] focus:outline-none focus:ring-none focus:border-primary sm:text-sm"
                :class="{ 'opacity-50 bg-gray-100 pointer-events-none': locked, 'border-red-300 text-red-900 focus:outline-none focus:ring-red-500 focus:border-red-500': errorMessage && meta.touched, 'min-h-[200px]': type === 'textarea' }"
                :name="name"
                :id="name"
                :type="type"
                :value="inputValue"
                :autocomplete="autocomplete"
                :placeholder="placeholder"
                @input="customHandleChange"
                @blur="handleBlur"
            />
            <div v-if="errorMessage && meta.touched" class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <ExclamationCircleIcon class="w-5 h-5 text-red-500" aria-hidden="true" />
            </div>
        </div>
    </BaseInput>
</template>
